import React, { memo, useCallback } from 'react';
import Button from '@components/atoms/Button';
import { EventType, trackEventWithCommonProps } from '@utils/eventTracker';
import { getLoginUrl } from '@utils/getLoginUrl';
import { STORAGE_KEYS, EVENT_TRACKING } from '@constants/carFinance';
import styles from './CarFinance.module.scss';
import { LoginSdkConfig } from '@enums/LoginSdkConfig';
import { handleLoginFlow } from "@utils/loginFlowHandler";

interface LoginButtonProps {
  pageType: string;
  carAvailability?: string;
  brandName: string;
  modelName: string;
  variantName: string;
  cityName: string;
}

export const LoginButton = memo(({
  pageType,
  carAvailability,
  brandName,
  modelName,
  variantName,
  cityName,
}: LoginButtonProps) => {
  const handleLoginClick = useCallback(async () => {
    await trackEventWithCommonProps(
      "action",
      EventType.TRACK_EVENT,
      {
        pageType: pageType,
        additionalProps: {
          action_type: EVENT_TRACKING.ACTION_TYPE,
          action_name: EVENT_TRACKING.ACTION_NAME,
          car_availability: carAvailability,
          vehicle_make: brandName,
          vehicle_model: modelName,
          vehicle_variant: variantName,
          city_name: cityName,
        },
      }
    );
    
    if (typeof window !== "undefined") {
      sessionStorage.setItem(STORAGE_KEYS.LOGIN_TYPE, "Car Finance");
      localStorage.setItem(
        STORAGE_KEYS.MMV_DATA,
        JSON.stringify({
          make: brandName,
          model: modelName,
          variant: variantName,
        })
      );
    }
    
    await handleLoginFlow(getLoginUrl(window.location.href), LoginSdkConfig.CALCULATE_EMI);
  }, [pageType, carAvailability, brandName, modelName, variantName, cityName]);

  return (
    <Button
      className={styles.financeButton}
      onClick={handleLoginClick}
    >
      Calculate your EMI
    </Button>
  );
});

LoginButton.displayName = 'LoginButton';
